import type { ApiError, PaginatedList } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { logError } from "@entrilia/shared/logging";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";
import NoDataResult from "../common/NoDataResult";
import NewsList from "./NewsList";

interface Props {
  newsPage: PaginatedList<InvestorCommunicationInfo> | undefined;
  fetchError: ApiError | undefined;
  isFetching: boolean;
  isFirstPage: boolean;
  newsPagePath: string;
}

const NewsPageContent = ({ newsPage, fetchError, isFetching, isFirstPage, newsPagePath }: Props) => {
  if (fetchError) {
    logError(fetchError, "[NewsPageContent] fetchError");
    return <DataLoadingFailed title="Failed to load news" />;
  }

  if (newsPage === undefined || isFetching) {
    return <InlineLoader />;
  }

  if (newsPage.items.length === 0) {
    return <NoDataResult text="No news found" />;
  }

  return <NewsList items={newsPage.items} isFirstPage={isFirstPage} newsPagePath={newsPagePath} />;
};

export default NewsPageContent;
